// extracted by mini-css-extract-plugin
module.exports = {"promptButtons":"_9d2a6ff","promptButton":"_e500521"};